import { ASTExplorer } from './ASTExplorer/ASTExplorer.blop'
import { TodoListPage } from './TodoListPage/TodoListPage.blop'
import { ShowcasePage } from './ShowcasePage/ShowcasePage.blop'
import { PlaygroundPage } from './PlaygroundPage/PlaygroundPage.blop'
import { FormBuilderPage } from './FormBuilderPage/FormBuilderPage.blop'
import './style.css' as style
import { go } from 'blop/navigation'

def navigationLinks() {
  def indexPage(e) {
    go('/')
    e.preventDefault()
  }
  def dogPage(e) {
    go('/dogs')
    e.preventDefault()
  }
  def todoPage(e) {
    go('/todo')
    e.preventDefault()
  }
  def astExplorerPage(e) {
    go('/ast')
    e.preventDefault()
  }
  def playgroundPage(e) {
    go('/playground')
    e.preventDefault()
  }
  def formPage(e) {
    go('/form')
    e.preventDefault()
  }
  return { dogPage, todoPage, astExplorerPage, playgroundPage, indexPage, formPage }
}

def navigation(state): VNode {
  links = navigationLinks()

  def navItem(pageType, handler, name) {
    classes = "nav-item"
    if state.route.name == pageType {
      classes := classes" active"
    }
    <li class=classes>
      <a href="/"pageType class="nav-link" on={ click: handler }>
        = name
      </a>
    </li>
  }

  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="/" on={ click: links.indexPage }>
      <img
        src="./blop.png"
        width="37" height="33" class="d-inline-block align-top" alt="" />
      = ' Blop'
    </a>
    <button class="navbar-toggler" type="button"
      data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        = navItem('playground', links.playgroundPage, 'Playground')
        = navItem('dog', links.dogPage, 'Breed game')
        = navItem('todo', links.todoPage, 'Advanced Todo')
        = navItem('ast', links.astExplorerPage, 'AST Explorer')
        = navItem('form', links.formPage, 'Form Builder')
      </ul>
      <div class=(style || {})['right-buttons']>
        if (state.loading) {
          <div class="spinner-border text-primary" role="status" style={ marginRight: '1em' }>
            <span class="sr-only">'Loading...'</span>
          </div>
        }
        = if state.error => <p>'Error 'state.error</p>
        <a href="https://github.com/batiste/blop-language" class="btn btn-secondary "(style || {}).btn"">
          = 'Fork on github'
        </a>
        <a href="https://github.com/batiste/blop-language/blob/master/docs/README.md"
          class="btn btn-secondary "(style || {}).btn"">
          = 'Docs'
        </a>
      </div>
    </div>
  </nav>
}



Index = (ctx: Component): VNode => {
  { state } = ctx.attributes
  { value as DogPage, setState as setDogPage } = ctx.state('dogPage', null)

  async def loadDog() {
    dogPageModule = await import('./DogPage/DogPage.blop')
    setDogPage(dogPageModule.DogPage)
  }

  <div>
    = navigation(state)
    console.log('Rendering page with state 'state.route.name)
    containerClass = 'container'
    if state.route.name == 'playground' || state.route.name == 'showcase' || state.route.name == 'root' {
      containerClass := 'container-fluid'
    }
    <div class=''(style || {}).container' 'containerClass>
      if state.route.name == 'showcase' {
        <ShowcasePage state=state></ShowcasePage>
      } elseif state.route.name == 'playground' {
        <PlaygroundPage state=state></PlaygroundPage>
      } elseif state.route.name == 'form' {
        <FormBuilderPage></FormBuilderPage>
      } elseif state.route.name == 'doggy' || state.route.name == 'dog' {
        if DogPage {
          <DogPage state=state></DogPage>
        } else {
          loadDog()
          <p>'Loading dog game...'</p>
        }
      } elseif state.route.name == 'todo' {
        <TodoListPage todo=state></TodoListPage>
      } elseif state.route.name == 'ast' {
        <ASTExplorer state=state></ASTExplorer>
      } else {
        <ShowcasePage state=state></ShowcasePage>
      }
    </div>
  </div>
}
